import React from "react";
import * as ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./index.css";
import App from "./App";
import SectorPostPage from './Pages/SectorPostspage'
import Error from './Pages/Error'
import BlogPage from './Pages/BlogPage'
import PrivacyPolicy from './Pages/PrivacyPolicy'
import LoginSignup from "./Pages/LoginPage";
import Signup from './Pages/Signup';
import AboutPage from './Pages/AboutPage';
import ContactPage from "./Pages/ContactPage";
import ComingSoon from './Components/ComingSoon';
import ProfilePage from "./Pages/ProfilePage";
import SearchResult from "./Pages/SearchResults";
const router = createBrowserRouter([
  {
    path: "/", // Root path
    element: <App />,
    errorElement: <Error />
  },
  {
    path: "/:category", // Root path
    element: <SectorPostPage />,
    errorElement: <Error />
  },
  {
    path: "/blogpage/:id", // Root path
    element: <BlogPage />,
    errorElement: <Error />
  },
  {
    path: "/PrivacyPolicy", // Root path
    element: <PrivacyPolicy />,
    errorElement: <Error />
  },
  {
    path: "/LoginSignup", // Root path
    element: <LoginSignup />,
    errorElement: <Error />
  },
  {
    path: "/Signup", // Root path
    element: <Signup />,
    errorElement: <Error />
  },
  {
    path: "/About", // Root path
    element: <AboutPage />,
    errorElement: <Error />
  },
  {
    path: "/Contact", // Root path
    element: <ContactPage />,
    errorElement: <Error />
  },
  {
    path: "/Comingsoon", // Root path
    element: <ComingSoon />,
    errorElement: <Error />
  },
  {
    path: "/search", // Root path
    element: <SearchResult />,
    errorElement: <Error />
  },
  {
    path: "/profile", // Root path
    element: <ProfilePage />,
    errorElement: <Error />
  }
])
ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);